// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"9d113cd0","151":"9080a0ca","161":"30909844","553":"edafe2e9","718":"a14ef99d","723":"006153fc","755":"3e9173c8","864":"8656e756","906":"241c175a"}[chunkId] + ".chunk.js";
};